import i18n from '@/i18n';

// 現在のロケールを取得するヘルパー関数
const getLocale = () => {
    try {
        return i18n.global.locale.value || 'ja';
    } catch (e) {
        return 'ja';
    }
};

// 翻訳キーから値を取得するヘルパー関数
const t = (key) => {
    try {
        return i18n.global.t(key);
    } catch (e) {
        return '';
    }
};

// 日付フォーマット
export const formatDate = (date) => {
    const locale = getLocale();
    const options = { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'Asia/Tokyo' };
    
    if (locale === 'ja') {
        return date.toLocaleDateString('ja-JP', options).replace(/(\d+)\/(\d+)\/(\d+)/, `$1${t('date_format.year')}$2${t('date_format.month')}$3${t('date_format.day')}`);
    } else {
        // 英語の場合は MM/DD/YYYY 形式
        return date.toLocaleDateString('en-US', options);
    }
};

export const formatDate2 = (date) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'Asia/Tokyo' };
    return date.toLocaleDateString('ja-JP', options).replace(/(\d+)\/(\d+)\/(\d+)/, '$1-$2-$3');
};

// 時刻フォーマット
export const formatTime = (date) => {
    const locale = getLocale();
    const options = { hour: 'numeric', minute: '2-digit', hour12: true, timeZone: 'Asia/Tokyo' };
    
    if (locale === 'ja') {
        return date.toLocaleTimeString('ja-JP', options).replace(/(午前|午後)/, '$1 ');
    } else {
        // 英語の場合は AM/PM 形式
        const timeString = date.toLocaleTimeString('en-US', options);
        return timeString.replace(/(AM|PM)/, (match) => {
            return match === 'AM' ? t('date_format.am') : t('date_format.pm');
        });
    }
};

// 日時フォーマット
export const formatDateTime = (date) => {
    const locale = getLocale();
    const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
    
    if (locale === 'ja') {
        return date.toLocaleString('ja-JP', options).replace(/(\d+)\/(\d+)\/(\d+), (\d+):(\d+)/, `$1${t('date_format.year')}$2${t('date_format.month')}$3${t('date_format.day')} $4${t('date_format.hour')}$5${t('date_format.minute')}`);
    } else {
        // 英語の場合は MM/DD/YYYY, HH:MM 形式
        return date.toLocaleString('en-US', options);
    }
};

// 日付フォーマット
export const formatResultTime = (date) => {
    const locale = getLocale();
    const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric' };
    
    if (locale === 'ja') {
        return date.toLocaleString('ja-JP', options).replace(/(\d+)\/(\d+)\/(\d+) (\d+):(\d+)/, `$1${t('date_format.year')}$2${t('date_format.month')}$3${t('date_format.day')} $4:$5`);
    } else {
        // 英語の場合は MM/DD/YYYY HH:MM 形式
        return date.toLocaleString('en-US', options);
    }
};

// PDF用日付フォーマット
export const formatPDFTime = (dateString) => {
    const date = new Date(dateString);
    const locale = getLocale();

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');

    if (locale === 'ja') {
        const period = hours < 12 ? ` ${t('date_format.am')}` : ` ${t('date_format.pm')}`;
        const formattedTime = `${year}${t('date_format.year')}${month}${t('date_format.month')}${day}${t('date_format.day')}${period}${hours}:${minutes}`;
        return formattedTime;
    } else {
        // 英語の場合は 12時間形式
        const period = hours < 12 ? t('date_format.am') : t('date_format.pm');
        let displayHours = hours;
        if (displayHours > 12) displayHours -= 12;
        if (displayHours === 0) displayHours = 12;
        const formattedTime = `${month}/${day}/${year} ${period} ${String(displayHours).padStart(2, '0')}:${minutes}`;
        return formattedTime;
    }
};

// タイムスタンプフォーマット
export const formatTimeStamp = (date) => {
    const locale = getLocale();
    const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
    
    if (locale === 'ja') {
        return date.toLocaleString('ja-JP', options).replace(/(\d+)年(\d+)月(\d+)日 (\d+)時(\d+)分/, '$1$2$3$4$5');
    } else {
        // 英語の場合は YYYYMMDDHHMM 形式
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}/${month}/${day} ${hours}:${minutes}`;
    }
};

// ファイル名フォーマット
export const formatFileData = (date) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
    return date.toLocaleString('ja-JP', options).replace(/(\d+)\/(\d+)\/(\d+) (\d+):(\d+)/, '$1$2$3_$4$5');
};

export const formatFileName = (date) => {
    const year = String(date.getFullYear()).slice(-2);
    const options = {month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'};
    const formattedDate = date.toLocaleString('ja-JP', options).replace(/(\d+)\/(\d+) (\d+):(\d+):(\d+)/, '$1$2$3$4$5');
    return `${year}${formattedDate}`;
}
